function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("rect", {
  id: "SVGID",
  width: 46.592,
  height: 59,
  transform: "translate(-557.129 1059.484)",
  fill: "#fff"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_25",
  "data-name": "Group 25",
  transform: "translate(-1322 -1985)"
}, React.createElement("rect", {
  id: "Rectangle_16",
  "data-name": "Rectangle 16",
  width: 100,
  height: 100,
  rx: 12,
  transform: "translate(1322 1985)",
  fill: "#c8232c"
}), React.createElement("g", {
  id: "Group_24",
  "data-name": "Group 24",
  transform: "translate(1906.129 946.516)",
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  id: "Path_43",
  "data-name": "Path 43",
  d: "M-516.626,1065.518a22.584,22.584,0,0,0-15.8-6.034c-9.366,0-15.127,3.84-18.31,7.06A20.861,20.861,0,0,0-556.9,1081c0,6.556,2.741,11.586,7.333,13.458a2.431,2.431,0,0,0,.922.19,2.049,2.049,0,0,0,2-1.65c.156-.584.515-2.022.671-2.647a2.484,2.484,0,0,0-.665-2.686,8.561,8.561,0,0,1-1.946-5.847c0-7.182,5.348-14.816,15.26-14.816,7.865,0,12.75,4.47,12.75,11.666a24.233,24.233,0,0,1-2.754,11.841c-1.234,2.151-3.405,4.715-6.738,4.715a4.465,4.465,0,0,1-3.552-1.624,4.087,4.087,0,0,1-.716-3.55c.351-1.484.829-3.032,1.292-4.528a28.015,28.015,0,0,0,1.641-7.374c0-3.523-2.166-5.89-5.389-5.89-4.1,0-7.3,4.16-7.3,9.47a14.115,14.115,0,0,0,1.005,5.3c-.515,2.186-3.582,15.184-4.164,17.635-.336,1.431-2.362,12.732.991,13.633,3.769,1.013,7.137-9.994,7.479-11.238.278-1.012,1.25-4.836,1.846-7.187a11.393,11.393,0,0,0,7.6,2.937,16.951,16.951,0,0,0,13.6-6.807c3.3-4.258,5.115-10.192,5.115-16.709a19.266,19.266,0,0,0-6-13.779Zm0,0",
  fill: "#fff"
})));

var SvgPinterest = function SvgPinterest(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPinterest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pinterest.34390b85.svg";
export { ForwardRef as ReactComponent };